(() => {
  const selector = 'delivery-promise-wc';
  const styleId = 'sb-unframed-delivery-promise';
  const css = '.ShopPromiseLayout__Clickable,.ShopPromiseLayout__Clickable .Box__Box,.PromiseShell__ShopPromise-SmoothContainer{background:transparent!important;border:0!important;box-shadow:none!important}';
  function apply(widget) {
    const root = widget.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.appendChild(style);
  }
  function scan() { document.querySelectorAll(selector).forEach(apply); }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches(selector)) apply(node);
        node.querySelectorAll(selector).forEach(apply);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
  let attempts = 0;
  const timer = setInterval(() => {
    scan();
    if (++attempts >= 40) clearInterval(timer);
  }, 500);
  if (window.customElements) customElements.whenDefined(selector).then(scan);
})();